import { render, staticRenderFns } from "./rescueCentersList.vue?vue&type=template&id=45e4dceb"
import script from "./rescueCentersList.vue?vue&type=script&lang=js"
export * from "./rescueCentersList.vue?vue&type=script&lang=js"
import style0 from "./rescueCentersList.vue?vue&type=style&index=0&id=45e4dceb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports